module.exports = "<ul uib-pagination rotate=true previous-text=Предыдущая items-per-page=20 next-text=Следующая max-size=3 total-items=$ctrl.data.totalItems ng-model=$ctrl.data.currentPage ng-disabled=$ctrl.data.disable boundary-link-numbers=true ng-change=$ctrl.onPaginationChange()></ul>";


//////////////////
// WEBPACK FOOTER
// ./src/components/linkedDocuments/search-pagination.html
// module id = 101
// module chunks = 0